import { render, staticRenderFns } from "./FormB2B.vue?vue&type=template&id=1c1917db&scoped=true"
import script from "./FormB2B.vue?vue&type=script&lang=js"
export * from "./FormB2B.vue?vue&type=script&lang=js"
import style0 from "./FormB2B.vue?vue&type=style&index=0&id=1c1917db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1917db",
  null
  
)

export default component.exports